'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { ExternLogo } from '@extern/ui/logos/extern-logo';
import { Text } from '@extern/ui/text';
interface LayoutProps {
  children: ReactNode;
}
export function CenteredAuthLayout(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex size-[72px] items-center justify-center rounded-full bg-white"><ExternLogo height={32} width={32} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text className="text-center" title="lg">Start Your Career <br />Journey with Extern</Text>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <div className="flex min-h-screen w-full flex-col items-center justify-center bg-role-surface"><div className="flex w-full max-w-full flex-col items-center gap-8 px-6 sm:w-[358px] sm:px-0">{t1}{t2}{children}</div></div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}